import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTwitter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="M22.362 12.737q.01.211.01.425c0 4.337-3.302 9.339-9.34 9.339A9.3 9.3 0 0 1 8 21.027q.386.045.783.045a6.6 6.6 0 0 0 4.077-1.405 3.285 3.285 0 0 1-3.067-2.279 3.3 3.3 0 0 0 1.483-.057 3.28 3.28 0 0 1-2.633-3.218v-.042c.442.246.949.394 1.487.411a3.28 3.28 0 0 1-1.016-4.383 9.32 9.32 0 0 0 6.766 3.43 3.283 3.283 0 0 1 5.593-2.994 6.6 6.6 0 0 0 2.085-.796 3.3 3.3 0 0 1-1.443 1.816A6.6 6.6 0 0 0 24 11.038a6.7 6.7 0 0 1-1.638 1.699M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.164 16-16S24.837 0 16 0"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTwitter);

export default ForwardRef;
